export default "/assets/3d3bd0835c258f5bd0bce57bb1963a9c.woff";